import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
  Router,
} from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { map, take } from 'rxjs/operators';
import { AuthService } from 'src/app/services/auth/auth.service';
import { LoginResponseData } from 'src/app/interfaces/LoginResponseData';

@Injectable({ providedIn: 'root' })
export class NonAuthGuard {
  private redirecting = false;

  constructor(
    private authService: AuthService,
    private router: Router,
  ) { }

  async canActivate(
    route: ActivatedRouteSnapshot,
    router: RouterStateSnapshot,
  ): Promise<boolean | UrlTree> {
    console.log('🚫 NON-AUTH GUARD DEBUG: Checking access for route:', route.routeConfig?.path);
    console.log('🚫 NON-AUTH GUARD DEBUG: Current URL:', router.url);

    // Special handling for wildcard routes
    if (route.routeConfig?.path === '**') {
      console.log('🚫 NON-AUTH GUARD DEBUG: Wildcard route detected, redirecting to login');
      return this.router.createUrlTree(['/']);
    }

    // Prevent infinite loops by checking if we're already on the login page
    if (router.url === '/' && route.routeConfig?.path === '') {
      console.log('🚫 NON-AUTH GUARD DEBUG: Already on login page, allowing access');
      return true;
    }

    let statusResponse: Observable<LoginResponseData> =
      await this.authService.checkStatus();
    let returnValue: Promise<boolean | UrlTree> = statusResponse
      .pipe(
        map((res: LoginResponseData) => {
          console.log('🚫 NON-AUTH GUARD DEBUG: Status check response:', res);

          if (res.status == 1) {
            console.log('🚫 NON-AUTH GUARD DEBUG: ✅ User authenticated (status 1), redirecting away from login');

            // Prevent infinite redirect loops
            if (this.redirecting) {
              console.log('🚫 NON-AUTH GUARD DEBUG: Already redirecting, allowing access to prevent loop');
              return true;
            }

            this.redirecting = true;
            console.log('🚫 NON-AUTH GUARD DEBUG: Using AuthService to redirect to first survey page');

            // Use AuthService to properly redirect to first survey page
            this.authService.redirectAuthenticatedUser();

            // Reset redirecting flag after a short delay
            setTimeout(() => {
              this.redirecting = false;
            }, 2000);

            // Return true to allow the redirect to proceed
            return true;
          } else if (res.status == 2) {
            console.log('🚫 NON-AUTH GUARD DEBUG: 🔄 User needs password change (status 2), redirecting');
            return this.router.createUrlTree(['requirepasswordchange']);
          } else {
            console.log('🚫 NON-AUTH GUARD DEBUG: ✅ User not authenticated, allowing access to login');
            return true;
          }
        }),
      )
      .toPromise() as Promise<boolean | UrlTree>;

    return returnValue;
  }

  // canActivate(
  //   route: ActivatedRouteSnapshot,
  //   router: RouterStateSnapshot
  // ):
  //   | boolean
  //   | UrlTree
  //   | Promise<boolean | UrlTree>
  //   | Observable<boolean | UrlTree> {
  //   return this.authService.user.pipe(
  //     take(1),
  //     map((user) => {
  //       const isAuth = !!(user ? (user.token ? user.token.length > 0 : false) : false);
  //       console.log(user);
  //       if (isAuth) {
  //         // return this.router.createUrlTree(['/survey/0']);
  //         return this.router.createUrlTree(['home']);
  //       }

  //       return true;
  //     })
  //   );
  // }
}
